import React, { useEffect, useState } from "react";
import applicationlogo from "@assets/logo/applicationlogo.png";
import SC from "./style";
import blur from "@assets/images/blur.png";
import ForgetPassword from "./ForgetPassword";
import RequestAccess from "./RequestAccess";
import LoginPage from "./WebLogin";

const Login = () => {
  const [currentView, setCurrentView] = useState("login");
  useEffect(() => {
    setCurrentView("login");
  }, []);

  const { REACT_APP_PRODUCT_NAME: productName } = process.env;

  return (
    <SC.Container>
      <SC.LogoLoginImage>
        <img
          src={blur}
          alt="Overlay"
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100vh",
            opacity: 0.9,
          }}
        />
        <SC.pdiv>
          Intelligently Store & Manage Your Building Records with{" "}
          <SC.textspan>{productName}</SC.textspan>
        </SC.pdiv>
      </SC.LogoLoginImage>
      <SC.Login>
        <SC.imagecontainer
          src={applicationlogo}
          alt="rsvplogo"
        ></SC.imagecontainer>
        {currentView === "login" && (
          <LoginPage setCurrentView={setCurrentView} />
        )}
        {currentView === "forgetpass" && (
          <ForgetPassword setCurrentView={setCurrentView} />
        )}
        {currentView === "requestaccess" && (
          <RequestAccess setCurrentView={setCurrentView} />
        )}
      </SC.Login>
    </SC.Container>
  );
};

export default Login;
